export default {
  setNetwork (state, value) {
    state.network = value
  },
  setAccount (state, value) {
    state.account = value
  },
}
